<template>
  <div
    class="default-layout">
    <slot />
  </div>
</template>

<style scoped>
.default-layout{
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
